import {
  Box,
  Typography,
  Container,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';

const Company = () => {
  const data = [
    { title: '会社名', value: '株式会社Next Episode(ネクストエピソード）' },
    { title: '代表者', value: '岩田　鮎 (Ayu Iwata)' },
    { title: '所在地', value: '東京都渋谷区円山町　6-7　アムフラット　1F' },
    { title: '電話番号', value: '03-5428-8256' },
    { title: '受付時間', value: '平日10:00-19:00　（土日祝は休業）' },
    { title: '設立年月', value: '2021年8月3日' },
    { title: '従業員数', value: '7名' },
  ];

  return (
    <Container
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '30px',
        height: '100vh',
        textAlign: 'center',
        padding: '16px',
      }}
    >
      <Box sx={{ width: '100%', maxWidth: '600px' }}>
        <Typography variant="h4" gutterBottom sx={{ fontFamily: "'Noto Serif JP', serif" }}>
          Company
        </Typography>
        <Typography gutterBottom variant="h5" component="div">
          会社概要
        </Typography>
        <Table
          sx={{
            width: '100%',
          }}
        >
          <TableBody sx={{ fontSize: '20px' }}>
            {data.map((item, index) => (
              <TableRow key={index}>
                <TableCell
                  sx={{
                    fontSize: {xs: '15px', md: '18px' },
                    fontWeight: 'bold',
                    backgroundColor: '#f5f5f5',
                    width: '30%',
                  }}
                >
                  {item.title}
                </TableCell>
                <TableCell sx={{ fontSize: {xs: '15px', md: '18px'} }}>{item.value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Container>
  );
};

export default Company;  
